import { Navigation, Swiper } from 'swiper';

export default class Testimonials {
    constructor(query) {
        const elems = document.querySelectorAll(query);
        if (!elems || !elems.length) return;

        this.query = query;
        this.elems = [...elems];

        this.init();
    }

    init() {
        this.setupSlider();
    }

    setupSlider() {
        this.elems.forEach((elem) => {
            const slider = elem.querySelector(`${this.query}__slider`);
            if (!slider) return;

            new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 2,
                spaceBetween: 16,
                observer: true,
                watchOverflow: true,
                navigation: {
                    prevEl: elem.querySelector(`${this.query}__navigation-prev`),
                    nextEl: elem.querySelector(`${this.query}__navigation-next`)
                },
                breakpoints: {
                    767: {
                        spaceBetween: 16,
                        slidesPerView: 2,
                    },
                    0: {
                        spaceBetween: 30,
                        slidesPerView: 1,
                    }
                }
            });
        });
    }
}
